<template>
  <section class="h-full flex flex-col justify-center items-center">
    <div
      class="mb-4 h-20 w-20 sm:h-32 sm:w-32 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center group"
    >
      <div
        class="relative h-10 w-10 sm:h-14 sm:w-14 border-4 border-primary-500 rounded-lg flex flex-col justify-around"
      >
        <div
          v-for="i in 3"
          :key="i"
          class="task-item px-0.5 flex gap-1 items-center after:h-0.5 after:w-0 after:bg-slate-400 dark:after:bg-white/50 after:animate-[expand_0.5s_ease-in-out_forwards]"
          :style="{ '--delay': `${i * 0.2}s` }"
        >
          <CheckIcon class="h-3 w-3" />
        </div>
        <span
          class="bg-slate-100 dark:bg-slate-800 absolute -bottom-4 -right-4 rounded-full text-slate-600 dark:text-slate-50"
        >
          <Cog6ToothIcon
            class="h-8 w-8 animate-[spin_12s_linear_infinite] group-hover:animate-[spin_2s_linear_infinite]"
          />
        </span>
      </div>
    </div>
    <h2 class="h2 text-center">
      {{ title || $t("newTask.upgradePlan") }}
    </h2>
    <p class="p max-w-lg text-center">
      {{ description || $t("freeTrialScheduledTaskInfo") }}
    </p>
    <component
      :is="billingStore.isNonStripeFreeTrialActive ? RouterLink : 'div'"
      :to="buttonTo || { name: RouteNames.PLANS, params: {} }"
      class="mt-4"
    >
      <AppButton
        :loading="isFetching"
        :label="buttonText || $t('words.Upgrade')"
        @click="maybeGoToStripe"
      />
    </component>
  </section>
</template>

<script setup lang="ts">
import { Cog6ToothIcon } from "@heroicons/vue/24/solid";
import { CheckIcon } from "@heroicons/vue/24/outline";
import { RouterLink } from "vue-router";
import Bugsnag from "@bugsnag/js";

const tour = useTourStore();
const billingStore = useBillingStore();
const { user } = useCurrentUser();
const { goToBillingUi, isFetching } = useUpgradePlanBillingLink(user);

const props = defineProps<{
  title?: string;
  description?: string;
  buttonText?: string;
  buttonTo?: any;
  skipTour?: boolean;
}>();

function maybeGoToStripe() {
  if (billingStore.isNonStripeFreeTrialActive || isFetching.value) return;
  goToBillingUi();
}

onBeforeMount(() => {
  try {
    if (
      props.skipTour ||
      tour.welcomeTour.complete ||
      tour.welcomeTour.skipped ||
      tour.isDismissed("tour_welcome-create-task-step") ||
      tour.isCompleted("create-task-tour")
    ) {
      return;
    }
    tour.startWelcomeTour("create-task-tour");
  } catch (error) {
    if (Bugsnag.isStarted()) Bugsnag.notify(error as Error);
    console.log("tour.startWelcomeTour onBeforeMount error");
  }
});
</script>

<style>
@keyframes expand {
  from {
    width: 0;
  }

  to {
    width: 24px;
  }
}

.task-item::after {
  animation-delay: var(--delay);
}
</style>
